import { Routes, Route, Navigate } from 'react-router-dom';
import { AppPrivateLayout } from '../components/AppPrivateLayout';
import { HomePage } from '../pages/HomePage';
import { DemandsListPage } from '../pages/DemandsListPage';
import { DemandDetailPage } from '../pages/DemandDetailPage';
import { TaskDetailPage } from '../pages/TaskDetailPage';
import { KanbanPage } from '../pages/KanbanPage';
import { UnauthorizedPage } from '../pages/UnauthorizedPage';
import { LogoutPage } from '../pages/LogoutPage';

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Protected routes (auth-guarded via AppPrivateLayout) */}
      <Route element={<AppPrivateLayout />}>
        <Route index element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/demands" element={<DemandsListPage />} />
        <Route path="/demands/:id" element={<DemandDetailPage />} />
        <Route path="/tasks/:id" element={<TaskDetailPage />} />
        <Route path="/kanban" element={<KanbanPage />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Route>
    </Routes>
  );
};
